import { render, staticRenderFns } from "./commodity-establish.vue?vue&type=template&id=27a5dcb4&scoped=true"
import script from "./commodity-establish.vue?vue&type=script&lang=js"
export * from "./commodity-establish.vue?vue&type=script&lang=js"
import style0 from "./commodity-establish.vue?vue&type=style&index=0&id=27a5dcb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5dcb4",
  null
  
)

export default component.exports